import { mainPostAListingRoute } from 'modules/main/main.routes';

import { PostOnIdealistDropdownData } from './PostOnIdealistDropdownData';

export const postOnIdealistDropdownDataPt: PostOnIdealistDropdownData = {
  triggerText: 'Criar Anúncio',
  triggerHref: mainPostAListingRoute.with({}),
  search: {
    title: 'Anunciar',
    items: [
      {
        type: 'post-a-listing',
        title: 'Criar um Anúncio',
        href: mainPostAListingRoute.with({}),
      },
      {
        type: 'create-org',
        title: 'Cadastre sua Organização',
        href: '/organizations/create',
      },
      {
        type: 'create-community-group',
        title: 'Cadastre seu Coletivo',
        href: '/organizations/create',
      },
    ],
  },
  resources: {
    title: 'Recursos',
    items: [
      {
        image: 'illustrations/talk-illustration.svg',
        title: 'Help Desk',
        description: 'Central de Atendimento',
        href: '/pt/ajuda',
      },
    ],
  },
};
